import { render, staticRenderFns } from "./EmbedInstructions.vue?vue&type=template&id=65bc02a3&"
import script from "./EmbedInstructions.vue?vue&type=script&lang=js&"
export * from "./EmbedInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports